export default {
  LOCALE: "es-ES",
  IMAGES_HOST: "https://static.filmin.es",
  FACEBOOK_LINK: "https://www.facebook.com/Filmin",
  TWITTER_LINK: "https://twitter.com/filmin",
  INSTAGRAM_LINK: "https://www.instagram.com/enfilmin/",
  LINKEDIN_LINK: "https://www.linkedin.com/company/filmin/mycompany/",
  PINTEREST_LINK: "https://www.pinterest.es/enfilmin/",
};
